import TileMinedLogic from "../../../logic/TileMinedLogic";
import { Settings } from "../../../Settings";
import Character from "../../character/Character";
import WorldGrid from "../../grid/WorldGrid";
import NumberValue from "../../value/NumberValue";
import OrbitPair from "./OrbitPair";

export default class Orbit {
    /**
     * @param {WorldGrid} worldGrid
     * @param {NumberValue} orbitRangeUpgrades
     * @param {NumberValue} orbMaxUpgrades
     * @param {TileMinedLogic} tileMinedLogic
     */
    constructor(worldGrid, orbitRangeUpgrades, orbMaxUpgrades, tileMinedLogic) {
        /**
         * @constant
         * @type {WorldGrid}
         */
        this.worldGrid = worldGrid;

        /**
         * @constant
         * @type {NumberValue}
         */
        this.orbitRangeUpgrades = orbitRangeUpgrades;
        /**
         * @constant
         * @type {NumberValue}
         */
        this.orbMaxUpgrades = orbMaxUpgrades;

        /**
         * @constant
         * @type {TileMinedLogic}
         */
        this.tileMinedLogic = tileMinedLogic;

        /**
         * @constant
         * @type {OrbitPair[]}
         */
        this.orbitPairs = [];

        /**
         * @type {number}
         */
        this.lastPairTime = 0;

        /**
         * @constant
         * @type {number}
         */
        this.orbitIntervalMillis = 500;

        /**
         * @type {boolean}
         */
        this.skillActive = false;
    }

    onSkillActivation() {

        this.skillActive = true;

        // The default range is 1 tile, but we don't want to count the tile the miner is standing in. Add 1.
        const maxPixelRange = Settings.skill.orbit.minRangePixels + (this.orbitRangeUpgrades.getValue() * Settings.skill.orbit.rangePixelsPerUpgrade);

        for (let i = 0; i < this.orbitPairs.length; i++) {
            this.orbitPairs[i].onSkillActivation(maxPixelRange);
        }
    }

    onSkillDeactivation() {
        this.skillActive = false;
    }

    /**
     * @param {Character} miner
     * @param {number} frameTimeRatio
     */
    updateForFrame(miner, frameTimeRatio) {

        // The min tile range is 2 so that the orb is 1 tile out from the miner.
        const pixelRange = Settings.skill.orbit.minRangePixels + (this.orbitRangeUpgrades.getValue() * Settings.skill.orbit.rangePixelsPerUpgrade);

        // Check to see if we have enough orbs
        let added = false;
        const maxCount = 1 + this.orbMaxUpgrades.getValue();
        while (this.orbitPairs.length < maxCount) {
            this.orbitPairs.push(new OrbitPair(this.worldGrid, this.tileMinedLogic, miner, pixelRange));

            added = true;
        }

        // If we added a pair, then re-initialize the radians of each one.
        if (added && this.orbitPairs.length > 1) {
            const radiansStep = (2 * Math.PI) / this.orbitPairs.length;
            
            let radians = 0;
            for (let i = 0; i < this.orbitPairs.length; i++) {
                this.orbitPairs[i].radians = radians;
                radians += radiansStep;
            }
        }

        for (let i = 0; i < this.orbitPairs.length; i++) {
            // We need to update the range each time.
            this.orbitPairs[i].range = pixelRange;

            this.orbitPairs[i].updateForFrame(frameTimeRatio);
        }
    }

}